//桌面快捷入口
var CommonUseButton = xClass("CommonUseButton", HomeSceneButton)

const RES = "homeicon/lobby_icon_common_use.png";
CommonUseButton.prototype.ctor = function () {
    let self = this
    HomeSceneButton.prototype.ctor.call(self, "设为常用", RES);
}

CommonUseButton.prototype.onCick = function () {
    let self = this
    if (self.isBusy) return;
    self.isBusy = true;
    window.mini.addCommonUse({
        success(res) {
            cc.log("设为常用成功");
            self.destroyBtn();
        },
        fail(err) {
            if (err.code === -10005) {
                cc.log("暂不支持该功能");
                // self.destroyBtn();
            } else {
                cc.log("设为常用失败", err.msg);
            }
        },
        complete(res) {
            self.isBusy = false;
        }
    })
}

CommonUseButton.prototype.onCleanup = function () {
    let self = this;
    console.error("CommonUseButton - onCleanup")
    ResManager.release([RES]);
}

CommonUseButton.prototype.destroyBtn = function () {
    let self = this;
    let btnLayer = require("clover/scene/HomeScene").getInstance().btnLayer;
    if (btnLayer.commonUseBtn) {
        btnLayer.removeBtnFromSelf(self);
        btnLayer.commonUseBtn = null;
    }
}

module.exports = CommonUseButton;
